<template>
  <div class="input-box">
    <div class="scroll">
      <label>
        <p>開始時間<span>*</span>：</p>
        <input type="time"
        v-model="inputEventStart" required>
      </label>
      <div class="radio-icons">
        <p>アイコン<span>*</span>：</p>
        <div class="icon">
          <label v-for="(icon, index) in icons" 
            :key="icon.name" @click="iconNumber=index">
            <input name="icons" type="radio" :value="icon.iconClass"
            v-model="inputEventIcon" 
            required>
            <i :class="[icon.iconClass, { select: iconNumber === index }]"></i>
          </label>
        </div>
      </div>
      <label>
        <p>イベント名<span>*</span>：</p>
        <input type="text"
        v-model="inputEventTitle" required>
      </label>
      <label>
        <p>メモ：</p>
        <textarea
        v-model="inputEventMemo" required></textarea>
      </label>
      <label>
        <p>リンク：</p>
        <input type="text"
        v-model="inputEventLink" required>
      </label>
      <label>
        <p>終了時間：</p>
        <input type="time"
        v-model="inputEventEnd" required>
      </label>
    </div>
    <div class="input-box-btns">
      <button @click="cancel">キャンセル</button>
      <template v-if="editModeE">
        <button @click="clearEventTime">クリア</button>
        <button @click="editEventTime">編集</button>
      </template>
      <template v-else>
        <button @click="newEventTime">決定</button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconNumber: "",
      icons: [
        {name:"plane", iconClass:"fas fa-plane fa-fw"},
        {name:"car", iconClass:"fas fa-car fa-fw"},
        {name:"bus", iconClass:"fas fa-bus-alt fa-fw"},
        {name:"restaurant", iconClass:"fas fa-utensils fa-fw"},
        {name:"cafe", iconClass:"fas fa-coffee fa-fw"},
        {name:"hotel", iconClass:"fas fa-bed fa-fw"},
        {name:"buildingA", iconClass:"fas fa-torii-gate fa-fw"},
        {name:"buildingB", iconClass:"fas fa-landmark fa-fw"},
        {name:"shopping", iconClass:"fas fa-shopping-cart fa-fw"},
        {name:"exchenge", iconClass:"fas fa-money-bill-alt fa-fw"},
        {name:"beach", iconClass:"fas fa-umbrella-beach fa-fw"},
        {name:"mountain", iconClass:"fas fa-mountain fa-fw"},
      ],
      inputEventStart: "",
      inputEventIcon: "",
      inputEventTitle: "",
      inputEventMemo: "",
      inputEventLink: "",
      inputEventEnd: "",
    }
  },
  computed: {
    dateObjects: {
      get() {
        return this.$store.getters.dateObjects;
      },
    },
    editModeE: {
      get() {
        return this.$store.getters.editModeE;
      },
    },
    editIndexD: {
      get() {
        return this.$store.getters.editIndexD;
      },
    },
    editIndexE: {
      get() {
        return this.$store.getters.editIndexE;
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.iconNumber = "";
      this.inputEventStart = "";
      this.inputEventIcon = "";
      this.inputEventTitle = "";
      this.inputEventMemo = "";
      this.inputEventLink = "";
      this.inputEventEnd = "";
    },
    newEventTime() {
      if (this.inputEventStart === "" | this.inputEventIcon === "" | this.inputEventTitle === "") {
        alert("入力されていない項目があります");
        return;
      }
      this.$emit('new-event', 
      this.inputEventStart, 
      this.inputEventIcon,
      this.inputEventTitle,
      this.inputEventMemo,
      this.inputEventLink,
      this.inputEventEnd);
      this.iconNumber = "";
      this.inputEventStart = "";
      this.inputEventIcon = "";
      this.inputEventTitle = "";
      this.inputEventMemo = "";
      this.inputEventLink = "";
      this.inputEventEnd = "";
    },
    clearEventTime() {
      this.iconNumber = "";
      this.inputEventStart = "";
      this.inputEventIcon = "";
      this.inputEventTitle = "";
      this.inputEventMemo = "";
      this.inputEventLink = "";
      this.inputEventEnd = "";
    },
    editEventTime() {
      if (this.inputEventStart === "" | this.inputEventIcon === "" | this.inputEventTitle === "") {
        alert("入力されていない項目があります");
        return;
      }
      this.$emit('edit-event', 
      this.inputEventStart, 
      this.inputEventIcon,
      this.inputEventTitle,
      this.inputEventMemo,
      this.inputEventLink,
      this.inputEventEnd);
      this.iconNumber = "";
      this.inputEventStart = "";
      this.inputEventIcon = "";
      this.inputEventTitle = "";
      this.inputEventMemo = "";
      this.inputEventLink = "";
      this.inputEventEnd = "";
    },
    selectedIcon(icon) {
      icon.selected = true;
    }
  },
  watch: {
    editModeE: function() {
      const vm = this;
      if (vm.editModeE === true) {
        vm.inputEventStart = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].startTime;
        vm.inputEventIcon = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].icon;
        vm.inputEventTitle = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].title;
        vm.inputEventMemo = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].memo;
        vm.inputEventLink = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].link;
        vm.inputEventEnd = vm.dateObjects[vm.editIndexD].events[vm.editIndexE].endTime;

      } else {
        vm.iconNumber = "";
        vm.inputEventStart = "";
        vm.inputEventIcon = "";
        vm.inputEventTitle = "";
        vm.inputEventMemo = "";
        vm.inputEventLink = "";
        vm.inputEventEnd = "";
      }
    }
  }
}
</script>

<style>

</style>